import { INotePreview } from '@/contracts/modules/note/entities/INotePreview'

export class NotePreview implements INotePreview {
  constructor(
    private uuid: string,
    private title: string,
    private updatedAt: string | null,
    private removed: boolean,
  ) {}

  getUuid(): string {
    return this.uuid
  }

  getTitle(): string {
    return this.title
  }

  getUpdatedAt(): string | null {
    return this.updatedAt
  }

  isRemoved(): boolean {
    return this.removed
  }
}
